// extracted by mini-css-extract-plugin
export default {"points-about-text":"HowToUsePoints_points-about-text__q0sk6","theme-grayscale":"HowToUsePoints_theme-grayscale__yAe-4"};